$(document).on('turbolinks:load', function() {
    filter_table("active") 

    $('#ctrl-show-by_activity').on('change', function () {
        filter_table($(this).val());
    });

});

function filter_table(val) {
    if(val == "active"){
        $("#villages_table tr").filter(function() {
            $(this).toggle($(this).text().indexOf("Inactive") == -1)
        });
    } else if(val == "inactive") {
        $("#villages_table tr").filter(function() {
            $(this).toggle($(this).text().indexOf("Inactive") > -1)
        });
    } else {
        $("#villages_table tr").filter(function() {
            $(this).toggle($(this).text().indexOf("") > -1)
        });
    }
}